module.exports = __webpack_public_path__ + "static/media/Transnational-entrepreneurship-bootcamp_Aug30.f17f77b2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/Misc/Transnational-entrepreneurship-bootcamp_Aug30.jpg
// module id = 971
// module chunks = 0